import { render, staticRenderFns } from "./ChatbotChat.vue?vue&type=template&id=14760470&scoped=true"
import script from "./ChatbotChat.vue?vue&type=script&lang=js"
export * from "./ChatbotChat.vue?vue&type=script&lang=js"
import style0 from "./ChatbotChat.vue?vue&type=style&index=0&id=14760470&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14760470",
  null
  
)

export default component.exports